/* eslint-disable import/prefer-default-export */
import { t } from '../i18n';

export const problemContent = {
    title: t('THE_PROBLEM'),
    subtitle_1: t('PROB_1_SUB'),
    body_1: [t('PROB_1_P1'), t('PROB_1_P2'), t('PROB_1_P3')],
    subtitle_2: t('PROB_2_SUB'),
    body_2: [t('PROB_2_P1'), t('PROB_2_P2')],
};
